import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login';

export const routes: Routes = [
    {
        path: '',
        component: LoginComponent
    },
    {
        path: ':id',
        component: LoginComponent
    }
];